export { default } from "../[companySlug]/categories/[categorySlug]";
export { getServerSideProps } from "../[companySlug]/categories/[categorySlug]";
